module.exports = __webpack_public_path__ + "img/stamp-hha.ef6345bb.png";